module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_western_clothing@2x-848aaca99f6d76912460c4335ce5d74d.webp";